import { SendAFormState } from './sendaform-types';

// todo - move ViewType, ShareType and other constants here
export { ShareType, LinkType, ValidationType } from '../publicshare/constants';

export const URL_IN_MESSAGE_ERROR = 'External URLs and hidden characters are not permitted for use in communication. For questions, contact support.';

export enum ViewType {
  FormView = 0,
  ListView = 1,
  Both = 2
}

export enum Steps {
  Loading = 0,
  ChooseSendType = 1,
  ChooseFormOrTemplate = 2,
  CaptureESign = 3,
  ChooseShareType = 4,
  RecipientDetails = 5,
  AvailableFields = 6,
  ConfigureLink = 7,
  ShareYourLink = 8,
  Error = 500,
  LoadForm = 600,
  LoadTemplate = 601,
  LoadPublicShare = 602
}

export const ALL_FIELDS_ID = 'all';
export const DEFAULT_FIELD_COLOR = '#D8F5FF'; // default-blue
export const TRANSPARENT_COLOR = '#00000000';
export const WHITE = '#FFFFFF';

export const DEFAULT_STATE: SendAFormState = {
  availableFields: [],
  completedSteps: {},
  currentStep: Steps.Loading,
  fieldColor: DEFAULT_FIELD_COLOR,
  linkName: '',
  message: {},
  messageSettings: {
    sharePdfAfterSubmission: true
  },
  recipient: {
    email: '',
    name: '',
    phoneNumber: ''
  },
  stepsMetadata: {
    [Steps.Loading]: { hideSteps: true },
    [Steps.ChooseSendType]: { hideSteps: true },
    [Steps.ChooseFormOrTemplate]: { hideSteps: true },
    [Steps.CaptureESign]: { hideSteps: true },
    [Steps.ChooseShareType]: { hideSteps: true },
    [Steps.ShareYourLink]: { hideSteps: true },
    [Steps.Error]: { hideSteps: true },
    [Steps.LoadForm]: { hideSteps: true },
    [Steps.LoadTemplate]: { hideSteps: true },
    [Steps.LoadPublicShare]: { hideSteps: true }
  }
};
